import axios from "axios";

import ENV from "../../util/env-config";
import { getSessionCookie } from "../../util/common";

class Service {
  static requestConfig() {
    return {
      headers: {
        Authorization: `Bearer ${getSessionCookie()}`,
      },
    };
  }

  static getImportLogForLocation(id) {
    return axios.post(`${ENV.systemBase}/import_location_logs`, { location_id: id }, this.requestConfig());
  }

  static createDealer(requestData) {
    return axios.post(`${ENV.dealerBaseUrl}/dealers/create`, requestData, this.requestConfig());
  }

  static createLocation(requestData) {
    return axios.post(`${ENV.dealerBaseUrl}/locations/create`, requestData, this.requestConfig());
  }

  static updateLocation(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/locations/update", requestData, this.requestConfig());
  }

  static getDealerDetail(requestData) {
    return axios.post(`${ENV.dealerBaseUrl}/dealers/details`, requestData, this.requestConfig());
  }

  static getLanguages() {
    return axios.get(ENV.systemBase + "/languages/list", this.requestConfig());
  }

  static uploadLogo(requestData) {
    return axios.post(ENV.dealerBaseUrl + "/dealers/logo/upload", requestData, this.requestConfig());
  }

  static deleteDealer(id) {
    return axios.post(ENV.dealerBaseUrl + "/dealers/delete", { id: id }, this.requestConfig());
  }

  static deleteLocation(id) {
    return axios.post(ENV.dealerBaseUrl + "/locations/delete", { id: id }, this.requestConfig());
  }

  static saveInvoicingAccount(requestData) {
    return axios.post(ENV.exactBase + "/accounts/save", requestData, this.requestConfig());
  }

  static linkInvoicingAccount(requestData) {
    return axios.post(ENV.exactBase + "/accounts/link", requestData, this.requestConfig());
  }

  static retrieveInvoicingAccount(requestData) {
    return axios.post(ENV.exactBase + "/accounts/retrieve", requestData, this.requestConfig());
  }

  static getDealers() {
    return axios.post(ENV.dealerBaseUrl + "/dealers/list", { embed: "dealer_location,number_of_missing_exact_licenses" }, this.requestConfig());
  }

  static retryExactInvoice(requestData) {
    return axios.post(ENV.exactBase + "/invoices/failed/retry", requestData, this.requestConfig());
  }

  static deleteFailedInvoice(requestData) {
    return axios.post(ENV.exactBase + "/invoices/failed/delete", requestData, this.requestConfig());
  }
}

export default Service;
